import { dataHooks } from '../../../../libs/dataHooks';
import { WidgetSlideDirection } from './WidgetSlideDirectionButton/WidgetSlideDirectionButton';

export const widgetDataHooks = dataHooks<{
  featureSlide;
  header;
  cover;
  carouselDots;
  directionButton: { direction: WidgetSlideDirection };
  background;
}>('widget');
